import React from 'react';
import { SurveyProvider } from '../../../assets/js/SurveyContext';
import QuestionGenerator from './QuestionGenerator';

const PromptSurvey = ({ onBack }) => (
  <SurveyProvider>
    <QuestionGenerator onBack={onBack} />
  </SurveyProvider>
);

export default PromptSurvey;
